import request from '@/utils/request'

export function getAll(page_size, currentPage, document) {
  return request({
    url: 'product/getAll/' + page_size +'/' + document + '?page=' + currentPage,
    method: 'get'
  })
}

export function search(query) {
  return request({
    url: 'product/search/' + query,
    method: 'get'
  })
}

export function edit(id) {
  return request({
    url: 'product/edit/' + id,
    method: 'get'
  })
}

export function store(data) {
  return request({
    url: 'product/save',
    method: 'post',
    headers: {
      'content-type': "multipart/form-data",
    },
    data
  })
}

export function storeVariations(data) {
  return request({
    url: 'product/save',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: 'product/update',
    method: 'post',
    headers: {
      'content-type': "multipart/form-data",
    },
    data
  })
}

export function destroy(id) {
  return request({
    url: 'product/destroy/' + id,
    method: 'delete'
  });
}

export function printLabels(data) {
  return request({
    url: 'product/printLabels',
    method: 'post',
    data,
    responseType: 'arraybuffer'
  })
}

export function storeFile(data) {
  return request({
    url: 'product/storeFile',
    method: 'post',
    headers: {
      'content-type': "multipart/form-data",
    },
    data
  })
}